export default "__VITE_ASSET__BpdJlfGp__"